import React from 'react';
import { Typography } from '@mui/material';
import { capitalize } from '../../../utils/strings';
import Root from './Root';

const CLASS_TEXTS = {
  points: 'A point type defines a sensor reading on a piece of equipment',
  equipment: 'An equipment type categorizes pieces of equipment with similar properties',
  measurements:
    'A measurement defines possible units and controls standardization for equipment sensor readings',
  location: 'Location defines a physical space',
  relationships:
    'Relationships model physical correspondences between an equipment or location and another equipment or location',
  modeling:
    'When Equipment and Points are published in the Staging Area they become part of the building model',
  glossary:
    'Glossary of commonly used terms in Onboard for describing building data. These are used across Staging, Explorer, and API.',
};

const RootClass = ({ type }) => {
  const text = CLASS_TEXTS[type];
  if (text) {
    return (
      <div className="leaf root-class">
        <Typography variant="h5" className="name">
          {capitalize(type)}
        </Typography>
        <Typography>{text}</Typography>
      </div>
    );
  }

  return <Root />;
};

export default RootClass;
